<div (click)="onClick($event)" class="wrapper">
  <div [title]="'Title'" class="map-control-btn" [ngClass]="{ 'mobile-btn': isMobile }">
    <i class="material-symbols-outlined no-location-icon">not_interested</i>
  </div>
</div>
